import { useMemo, useState } from "react";

import {
  Box,
  Container,
  Heading,
  VStack,
  Text,
  HStack,
  CircularProgress,
  Breadcrumb,
  BreadcrumbItem,
  //   FormControl,
  List,
  useDisclosure,
  ListItem,
  Button as CButton,
} from "@chakra-ui/react";

import { ChevronRightIcon, ChevronLeftIcon } from "@chakra-ui/icons";

import {
  Pagination,
  PaginationContainer,
  PaginationNext,
  PaginationPage,
  PaginationPageGroup,
  PaginationPrevious,
  PaginationSeparator,
  usePagination,
} from "@ajna/pagination";
// import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Input from "components/Input/Input";
import Button from "components/Button/Button";
// import Select from "components/Select/Select";

import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import TransactionDetailModal from "components/Modals/wallet/TransactionDetails";

// import { useHistory } from "react-router-dom";

import { CgDatabase } from "react-icons/cg";

// import formatter from "util/formatter";
import toPrecision from "util/toPrecision";
import { clamp } from "util/utils";

import { useGetWalletTransationsV2Query } from "services/walletApi";
import { format, parseISO } from "date-fns";
import toLower from "lodash/toLower";
import toUpper from "lodash/toUpper";
import Select from "components/Select/Select";

export const TransactionItem = ({
  type,
  currency,
  description,
  createdAt,
  value,
  transactionId,
  tx,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  // console.log("transaction id", transactionId);

  const getColor = (type) => {
    const map = {
      credit: "#00BA88",
      debit: "#ED2E7E",
    };

    return map[toLower(type) ?? "credit"];
  };

  const getType = (type) => {
    const map = {
      [toLower(type)]: toLower(type).includes("debit") ? "debit" : "credit",
      contract_credit: "credit",
      contract_debit: "debit",
    };

    return map[toLower(type)];
  };

  return (
    <>
      <ListItem
        w="100%"
        as={CButton}
        minH="fit-content"
        bg="transparent"
        p="32px 0"
        borderRadius="2px"
        borderBottom={
          // i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
          "1px solid #EAEAEA"
        }
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onOpen}
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={getColor(getType(type))}
            />
            <Box maxW="180px">
              <Text
                textAlign="left"
                fontSize="sm"
                fontWeight="500"
                color="#595B67"
                w="100%"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                m="0 !important"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="12px" mt="2px">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text>
            {getType(type) === "debit" ? "-" : ""}
            {/* {formatter(currency).format(value?.$numberDecimal)} */}
            {toPrecision(value?.$numberDecimal, currency)}
          </Text>
        </HStack>
      </ListItem>

      <TransactionDetailModal
        type={type}
        description={description}
        amount={value?.$numberDecimal}
        createdAt={createdAt}
        currency={currency}
        txId={transactionId}
        title={`${description} Details`}
        onClose={onClose}
        isOpen={isOpen}
        tx={tx}
      />
    </>
  );
};

const WalletTransactions = (props) => {
  //   const history = useHistory();

  const wallet = props?.match?.params?.coin;

  const [filterQueries, setFilterQueries] = useState(
    `page=1&limit=10&sortBy=createdAt:desc&unit=${wallet}`
  );

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [txType, setTxType] = useState("");

  const { data, isLoading, isFetching } =
    useGetWalletTransationsV2Query(filterQueries);

  const totalTx = useMemo(() => data?.totalCount, [data]);
  const transactions = useMemo(() => data?.transactions, [data]);

  console.log("TRANSACTIONS", transactions);

  const {
    pages,
    pagesCount,
    offset,
    currentPage,
    setCurrentPage,
    isDisabled,
    pageSize,
  } = usePagination({
    total: totalTx,
    limits: {
      outer: 1,
      inner: 1,
    },
    initialState: {
      pageSize: 10,
      isDisabled: false,
      currentPage: 1,
    },
  });

  // console.log("DATES", startDate, endDate);

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
    const searchQuery = new URLSearchParams(filterQueries);
    searchQuery.set("page", nextPage);
    // console.log("SEARCH QUERY", path);
    setFilterQueries(searchQuery.toString());
  };

  const applyFilters = () => {
    const searchQuery = new URLSearchParams(filterQueries);
    if (startDate) searchQuery.set("afterDate", startDate);
    if (endDate) searchQuery.set("beforeDate", endDate);

    if (txType && txType === "all") searchQuery.delete("operation");
    if (txType && txType !== "all") searchQuery.set("operation", txType);

    (startDate || endDate || txType) &&
      setFilterQueries(searchQuery.toString());
  };

  const motionKey = useMemo(
    () =>
      `transactions-motion-${
        isLoading ? "loading" : !isLoading ? "loaded" : "moving"
      }`,
    [isLoading]
  );

  const isFilterDisabled = useMemo(
    () => !(startDate || endDate || txType),
    [startDate, endDate, txType]
  );

  // console.log("TRANSACTIONS", transactions);
  console.log("Transaction Type", txType);

  return (
    <Box>
      <Sidemenu currentPage={"Wallet"} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["0", "0", "0"]}>
              <HStack>
                <Heading>Transactions</Heading>
                {isFetching && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                )}
              </HStack>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/wallet">Wallet</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet/${wallet}`}>
                    {toUpper(wallet)}
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Transactions
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              maxW="100%"
              // w="fit-content"
              mt="22px"
              borderRadius="8px"
              p="28px"
            >
              <HStack
                mb="20px"
                alignItems={["flex-start", "flex-end"]}
                flexDir={["column", "column", "row"]}
              >
                <HStack>
                  <Input
                    label="Start Date"
                    type="date"
                    minH="42px"
                    maxW={["180px", "100%"]}
                    flex="1"
                    value={startDate ?? ""}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <Input
                    ml={["0 !important", "0 !important", "0"]}
                    label="End Date"
                    type="date"
                    minH="42px"
                    maxW={["180px", "100%"]}
                    flex="1"
                    value={endDate ?? ""}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                  <Select
                    ml={["0 !important", "0 !important", "0"]}
                    label="Type"
                    minH="42px"
                    maxW={["180px", "100%"]}
                    flex="1"
                    value={txType ?? ""}
                    onChange={(e) => setTxType(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="credit">Credit</option>
                    <option value="debit">Debit</option>
                  </Select>
                </HStack>

                <Button
                  minH="42px"
                  ml={["0 !important", "0 !important", "1em !important"]}
                  mt={["1em !important", "1em !important", "initial"]}
                  w={["100%", "initial"]}
                  onClick={applyFilters}
                  disabled={isFilterDisabled}
                >
                  Filter
                </Button>
              </HStack>

              <AnimatePresence initial={false}>
                <motion.div
                  key={motionKey}
                  initial={{ opacity: 0, scale: 0.94 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.94 }}
                >
                  {transactions?.length < 1 && !isLoading && !isFetching && (
                    <VStack py="32px">
                      <Box as={CgDatabase} fontSize="48px" color="grey" />
                      <Text color="grey">No Data</Text>
                    </VStack>
                  )}

                  {isFetching && (
                    <VStack py="32px">
                      <CircularProgress
                        ml="20px !important"
                        isIndeterminate
                        color="var(--primary)"
                        size="20px"
                      />
                    </VStack>
                  )}

                  {transactions && !isLoading && (
                    <List mt="12px">
                      {transactions.map((tx, i) => (
                        <TransactionItem
                          key={`transaction-item-${i}`}
                          {...tx}
                          transactionId={tx?._id}
                          currency={tx.unit}
                          tx={tx}
                        />
                      ))}
                    </List>
                  )}
                </motion.div>
              </AnimatePresence>
            </Box>

            {!isLoading && transactions?.length > 0 && (
              <Box className="paginate-box">
                <HStack
                  // bg="white"
                  // p="10px 40px"
                  justifyContent="space-between"
                  borderRadius="0px 0px 16px 16px"
                  flexDir={["column", "row"]}
                  w="100%"
                  mt="0 !important"
                >
                  <Text>
                    Showing {offset + 1} to{" "}
                    {clamp(offset + pageSize, pageSize, totalTx ?? 0)} of{" "}
                    {totalTx ?? 0}
                  </Text>

                  <HStack>
                    <Pagination
                      pagesCount={pagesCount}
                      currentPage={currentPage}
                      isDisabled={isDisabled}
                      onPageChange={handlePageChange}
                    >
                      <PaginationContainer
                        align="center"
                        justify="space-between"
                        py={4}
                        w="full"
                      >
                        <PaginationPrevious
                          mr="8px"
                          boxSize="32px"
                          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                          _active={{ bg: "transparent" }}
                          _hover={{
                            bg: "transparent",
                          }}
                          bg="transparent"
                        >
                          <ChevronLeftIcon />
                        </PaginationPrevious>
                        <PaginationPageGroup
                          isInline
                          align="center"
                          separator={
                            <PaginationSeparator
                              border="1px solid #DFE3E8"
                              bg="transparent"
                              fontSize="sm"
                              boxSize="32px"
                              jumpSize={4}
                              _active={{ bg: "transparent" }}
                              _hover={{
                                bg: "transparent",
                              }}
                              _focus={{
                                borderColor: "transparent",
                                shadow: "0 0 0 3px var(--focusColor)",
                              }}
                            />
                          }
                        >
                          {pages.map((page) => (
                            <PaginationPage
                              boxSize="32px"
                              bg="transparent"
                              border="1px solid #DFE3E8"
                              key={`pagination_page_${
                                page || Math.random() * 7676767665453
                              }`}
                              page={page}
                              fontSize="sm"
                              _active={{ bg: "transparent" }}
                              _hover={{
                                bg: "transparent",
                              }}
                              _focus={{
                                borderColor: "transparent",
                                shadow: "0 0 0 3px var(--focusColor)",
                              }}
                              _current={{
                                borderColor: "transparent",
                                bg: "#03a438",
                                fontSize: "sm",
                                boxSize: "32px",
                                color: "white",
                                _hover: {
                                  borderColor: "#DFE3E8",
                                  bg: "transparent",
                                  color: "black",
                                },
                              }}
                            />
                          ))}
                        </PaginationPageGroup>
                        <PaginationNext
                          ml="8px"
                          boxSize="32px"
                          _active={{ bg: "transparent" }}
                          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                          _hover={{
                            bg: "transparent",
                          }}
                          bg="transparent"
                        >
                          <ChevronRightIcon />
                        </PaginationNext>
                      </PaginationContainer>
                    </Pagination>
                  </HStack>
                </HStack>
              </Box>
            )}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default WalletTransactions;
